import { render, staticRenderFns } from "./cardeptspace.vue?vue&type=template&id=3da9fb9c&scoped=true&"
import script from "./cardeptspace.vue?vue&type=script&lang=js&"
export * from "./cardeptspace.vue?vue&type=script&lang=js&"
import style0 from "./cardeptspace.vue?vue&type=style&index=0&id=3da9fb9c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3da9fb9c",
  null
  
)

export default component.exports